import * as React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import OrderTabNavigator from './OrderTabNavigator';
import OrderGroupSingleScreen from '../screens/order/OrderGroupSingle';
import OrderGroupInvoiceScreen from '../screens/order/OrderGroupInvoice';

const Stack = createStackNavigator();
const INITIAL_ROUTE_NAME = 'OrderList';

export default function OrderNavigator() {

  return (
    <Stack.Navigator initialRouteName={INITIAL_ROUTE_NAME} headerMode="none">
      <Stack.Screen
        name="OrderList"
        component={OrderTabNavigator}
      />
      <Stack.Screen
        name="OrderSingle"
        component={OrderGroupSingleScreen}
        options={{
          title: 'Order'
        }}
      />
      <Stack.Screen
        name="OrderInvoice"
        component={OrderGroupInvoiceScreen}
        options={{
          title: 'Invoice'
        }}
      />
    </Stack.Navigator>
  );
}

